import type { IconData } from '@stacksjs/iconify-core'

export const arrowDown: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M622 106L311 417L0 106l65-65l246 245L556 41z\"/>",
  "width": 630,
  "height": 700,
  "viewBox": "0 0 630 700"
}

export default arrowDown
